module.exports = __webpack_public_path__ + "58cf5e517dd36a41bffed065c5afb073.woff2";